import OdmietnutieGestoraPage from './OdmietnutieGestoraPage';

export default OdmietnutieGestoraPage;
